import React, { useState, useEffect } from 'react'
import CheckAuth from '../../elements/checkAuth';
import axios from 'axios';
import config from '../../../../config/environment';
import queryString from 'query-string';
import '../../../../styles/table.admin.css';
import './history.css';
import Menu from '../../elements/Menu/menu';

export default function AdminHistory () {
    const [ state, setState ] = useState({
        ordersHistory: null,
        numberOfRecords: 50,
        mode: 'ALL'
    });

    useEffect(() => {
        const main = async () => {
            try {
                const url = window.location.href;
                const urlParamsString = url.slice((url.indexOf('?')) + 1);
                const urlParamsObj = queryString.parse(urlParamsString);

                const numberOfRecords = urlParamsObj.numberOfRecords || 50;

                const response = await axios.get(config.backendUrl + '/order/history?numberOfRecords=' + numberOfRecords, { headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                } });

                const ordersHistory = response.data;

                setState(state => { return { ...state, ordersHistory, numberOfRecords } });

            } catch (error) {
                console.log(error.message);
                console.log(error.response.data.message);
            }
        };
        main();
    }, []);

    const modeHandler = mode => setState({ ...state, mode });

    const renderModes = () => {
        if (!state.ordersHistory) { return; }

        return(
            <div className="history__modeSelector_wrapper">
                {
                  Object.keys(state.ordersHistory).map((modeName, index) => {
                    return(
                        <>
                            <input type="radio" name="mode" id={ modeName + 'RadioInput' }
                                value={ modeName.toUpperCase() } onChange={event => modeHandler(event.target.value)} checked={ modeName.toUpperCase() === state.mode } />
                            <label className="history__modeSelector_label" htmlFor={ modeName + 'RadioInput' }>{ modeName.toUpperCase() }</label>
                        </>
                    );
                  })
                }
            </div>
        );
    };

    const renderTable = () => {
        if (!state.ordersHistory) { return; }

        return(
            <div className="history__table_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Order hash</th>
                            <th>Type</th>
                            <th>Rate type</th>
                            <th>Provider</th>
                            <th>In currency</th>
                            <th>Out currency</th>
                            <th>In payway</th>
                            <th>Out payway</th>
                            <th>Out destination</th>
                            <th>Amount received</th>
                            <th>Expected amount</th>
                            <th>Withdrawn amount</th>
                            <th>Cashback token</th>
                            <th>Parent cashback token</th>
                        </tr>
                    </thead>
                    <tbody>
                        { state.ordersHistory[ state.mode.toLowerCase() ].map((orderInfo, index) => {
                            return(
                                <tr key={ index }>
                                    <td>{ orderInfo.date }</td>
                                    <td>{ orderInfo.orderHash }</td>
                                    <td>{ orderInfo.exchangeWayType }</td>
                                    <td>{ orderInfo.rateType }</td>
                                    <td>{ orderInfo.providerName }</td>
                                    <td>{ orderInfo.inCurrencyCode }</td>
                                    <td>{ orderInfo.outCurrencyCode }</td>
                                    <td>{ orderInfo.inPaywayCode }</td>
                                    <td>{ orderInfo.outPaywayCode }</td>
                                    <td>{ orderInfo.outDestination }</td>
                                    <td>{ orderInfo.amountReceived }</td>
                                    <td>{ orderInfo.expectedAmount }</td>
                                    <td>{ orderInfo.withdrawnAmount }</td>
                                    <td>{
                                        orderInfo.cashbackToken ?
                                            <a href={ '/skr/order-info?cashbackToken=' + orderInfo.cashbackToken } target="_blank">{
                                                orderInfo.cashbackToken + (orderInfo.cashbackLabel ? (' [' + orderInfo.cashbackLabel + ']') : '')
                                            }</a>
                                            : '–'    
                                    }</td>
                                    <td>{
                                        orderInfo.parentCashbackToken ?
                                            <a href={ '/skr/order-info?cashbackToken=' + orderInfo.parentCashbackToken } target="_blank">{
                                                orderInfo.parentCashbackToken + (orderInfo.parentCashbackLabel ? (' [' + orderInfo.parentCashbackLabel + ']') : '')
                                            }</a>
                                            : '–'
                                    }</td>
                                </tr>
                            )
                        }) }
                    </tbody>
                </table>
            </div>
        );
    };

    const recordsSelectorChangeHandler = async (numberOfRecords) => {
        try {
            const response = await axios.get(config.backendUrl + '/order/history?numberOfRecords=' + numberOfRecords, { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } });

            const ordersHistory = response.data;

            setState(state => { return { ...state, ordersHistory, numberOfRecords } });

        } catch (error) {
            console.log(error.message);
            console.log(error.response.data.message);
        }
    };

    const renderRecordsSelector = () => {
        return(
            <div className="history__recordsSelector_wrapper">
                <select value={ state.numberOfRecords || 'DEFAULT' } onChange={event => recordsSelectorChangeHandler(event.target.value)}>
                    <option value="DEFAULT">Select the number of rows</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                </select>
            </div>
        );
    };

    return (
        <>
            <CheckAuth />
            <div>
                <Menu />
                { renderModes() }
                { renderTable() }
                { renderRecordsSelector() }
            </div>
        </>
    )
}